var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.68799 4.8035C6.88777 4.98824 7 5.23877 7 5.5C7 5.76123 6.88777 6.01176 6.68799 6.1965L1.79343 10.7213C1.59491 10.9011 1.32763 11.0013 1.04967 11C0.771718 10.9987 0.505548 10.896 0.309002 10.7143C0.112456 10.5326 0.00141732 10.2866 1.3474e-05 10.0296C-0.00139037 9.77268 0.106955 9.52559 0.301505 9.34207L4.45757 5.5L0.301505 1.65793C0.106955 1.47441 -0.00139037 1.22732 1.3474e-05 0.970369C0.00141732 0.713414 0.112456 0.467353 0.309002 0.285657C0.505548 0.10396 0.771718 0.00131024 1.04967 1.24561e-05C1.32763 -0.00128533 1.59491 0.0988741 1.79343 0.278726L6.68799 4.8035Z",
    fill: "#0044CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightActive);
export default __webpack_public_path__ + "static/media/arrowRightActive.48141aef7ec5ffc741711f00a0da2cbd.svg";
export { ForwardRef as ReactComponent };